// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/SwitchesPanel/SwitchesPanel.less
// module id = 238
// module chunks = 2